window.addEventListener('scroll', function () {
  let stickyForm = document.getElementById('sticky-info-bar');
  let elementTarget = document.querySelector('.banner_landing');
  let headerElement = document.getElementById('shopify-section-header');
  let totalToScrollHeight = 0;

  if (window.innerWidth >= 990) {
    totalToScrollHeight = elementTarget.offsetTop + elementTarget.offsetHeight + headerElement.offsetHeight;
  } else {
    totalToScrollHeight = elementTarget.offsetHeight + headerElement.offsetHeight;
  }

  if (window.scrollY > totalToScrollHeight) {
    stickyForm.classList.remove('sticky-form-hidden');
  } else {
    stickyForm.classList.add('sticky-form-hidden');
  }
});
